import {
  removeJWTLocalStorage,
  removeREFRESHLocalStorage,
  removeUSERFromLocalStorage,
} from "./localStorage";
import { SIGNIN_REDIRECT_STORAGE_KEY } from "./signInRedirect";
import { markAuthRevoked } from "./authSession";

const LEGACY_KEYS = ["access", "refresh", "educator_user"];

/** Query flag on `/signin` after sign-out — blocks auto-redirect back to educator dashboard. */
export const SIGNED_OUT_QUERY_PARAM = "signedOut";

/** Clear JWT, user, and sign-in redirect state on the main app origin. */
export function clearAppSession() {
  removeUSERFromLocalStorage();
  removeJWTLocalStorage();
  removeREFRESHLocalStorage();
  LEGACY_KEYS.forEach((k) => {
    try {
      localStorage.removeItem(k);
    } catch {
      /* ignore */
    }
  });
  try {
    sessionStorage.removeItem(SIGNIN_REDIRECT_STORAGE_KEY);
  } catch {
    /* ignore */
  }
  markAuthRevoked();
}

export function getMainSignInUrl({ afterSignOut = false } = {}) {
  if (typeof window === "undefined") {
    return afterSignOut ? `/signin?${SIGNED_OUT_QUERY_PARAM}=1` : "/signin";
  }
  const base = `${window.location.origin}/signin`;
  return afterSignOut ? `${base}?${SIGNED_OUT_QUERY_PARAM}=1` : base;
}

/** Educator app `/signout` — clears that origin, then redirects to `return`. */
export function getEducatorSignOutUrl(returnAfterUrl) {
  const base = process.env.REACT_APP_EDUCATOR_URL;
  if (!base || typeof base !== "string") return null;
  const signout = `${base.replace(/\/$/, "")}/signout`;
  const ret = returnAfterUrl || getMainSignInUrl();
  return `${signout}?return=${encodeURIComponent(ret)}`;
}

/**
 * Full sign-out from the main app: clear this origin, then clear educator origin if configured.
 */
export function performMainAppSignOut({ chainEducatorClear = true } = {}) {
  clearAppSession();
  const signInUrl = getMainSignInUrl({ afterSignOut: true });
  if (chainEducatorClear) {
    const educatorSignOut = getEducatorSignOutUrl(signInUrl);
    if (educatorSignOut) {
      window.location.replace(educatorSignOut);
      return;
    }
  }
  window.location.replace(getMainSignInUrl({ afterSignOut: true }));
}
